import { LI_Container, LI_Lock, LI_Wrapper } from "./LessonItem.styled";
import { LessonStore } from "../../../../../../../../../../stores/lessons/lesson.store";
import { GrandChartAccess } from "../../../../../../../../../../interfaces";
import { ServiceName } from "../../../../../../../../../../constants";
import { CircleProgressBar } from "../../../../../../../../CircleProgressBar/CircleProgressBar";
import * as React from "react";
import { calculatePercent } from "../../../../../../../../../../helpers";
import { observer } from "mobx-react";
import { useStores } from "../../../../../../../../../../stores";
import { useNavigate } from "react-router-dom";
import { IconLock } from "../../../../../../../../Icons";

interface LessonItemProps {
	isFirst: boolean;
	isFirstGroupLesson: boolean;
	service: ServiceName;
	access: GrandChartAccess;
	lessonStore: LessonStore;
}

export const LessonItem = observer(({ isFirst, isFirstGroupLesson, service, access, lessonStore }: LessonItemProps) => {
	const { statisticsStore, accessLimitedStore, grandCharts } = useStores();

	const navigate = useNavigate();

	const currentPassedSecond = statisticsStore.getByLessonUUID(lessonStore.uuid);
	const currentPassedProgress = calculatePercent(lessonStore.duration_second, currentPassedSecond);

	const isDisabled = (() => {
		if (access === GrandChartAccess.FULL) {
			return false;
		}

		if (access === GrandChartAccess.TRIAL) {
			return !isFirst || !isFirstGroupLesson;
		}

		if (access === GrandChartAccess.DENIED) {
			return true;
		}

		return true;
	})();

	const handleOnGoToLesson = async () => {
		if (isDisabled) {
			accessLimitedStore.modal.open();
			return;
		}

		grandCharts.modal.close();
		navigate(`/cabinet/lessons/${lessonStore.uuid}`);
	};

	return (
		<LI_Container>
			<LI_Wrapper
				$service={service}
				$disabled={isDisabled}
				$color={lessonStore.color.color}
				onClick={handleOnGoToLesson}
			>
				<CircleProgressBar
					strokeWidth={2}
					sqSize={44}
					percentage={currentPassedProgress}
					payload={lessonStore.sort}
					color={lessonStore.color.color}
				/>

				{isDisabled && (
					<LI_Lock>
						<IconLock />
					</LI_Lock>
				)}
			</LI_Wrapper>
		</LI_Container>
	);
});
